// extracted by mini-css-extract-plugin
module.exports = {"like-box":"like_like-box__1_xfG","like-img":"like_like-img__10Sd-"};